"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TooltipForTruncatedText = ({
  open,
  children,
  ...props
}) => {
  const [opened, setOpened] = _react.default.useState(false);

  const onMouseEnter = e => {
    setOpened(e.target.scrollWidth > e.target.clientWidth);
  };

  const onMouseLeave = () => {
    setOpened(false);
  };

  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, _extends({
    open: opened,
    onMouseEnter: onMouseEnter,
    onMouseOut: onMouseLeave,
    disableHoverListener: true
  }, props), children);
};

var _default = TooltipForTruncatedText;
exports.default = _default;